import styled from "styled-components";

export const Root = styled.div`
  .gatsby-image-wrapper {
    border-radius: 16px;
    height: 400px;

    ${({ theme }) => theme.breakpointsV2.smallTablet} {
      height: 440px;
    }

    ${({ theme }) => theme.breakpointsV2.smallDesktop} {
      height: 540px;
    }
  }
`;
